import React, { Component } from 'react'
import EirOnlineMedicalForm from './EirOnlineMedicalForm';
import EirOnlineBereavementForm from './EirOnlineBereavementForm';
import EirOnlineAuthorizedUserForm from './EirOnlineAuthorizedUserForm';
import EirOnlineRefundRequestForm from './EirOnlineRefundRequestForm';
import EirOnlineUnlockingCodeForm from './EirOnlineUnlockingCodeForm';

export class EirOnlineFormLandingPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
          formDetails: this.props,
        };
      }
      renderForm = () => {
        
        switch (this.props.formName.toLocaleLowerCase().trim()) {
            case 'medical-incapacitation':
                return <EirOnlineMedicalForm  action={this.props.formAction} email={this.props.email} formName={this.props.formName}/>;
            case 'bereavement':
                return <EirOnlineBereavementForm action={this.props.formAction} email={this.props.email} formName={this.props.formName}/>;
            case 'authorized-user':
                return <EirOnlineAuthorizedUserForm action={this.props.formAction} email={this.props.email} formName={this.props.formName} successMsg={this.props.successMsg}/>;
            case 'refund-request':
                return <EirOnlineRefundRequestForm action={this.props.formAction} email={this.props.email} formName={this.props.formName} successMsg={this.props.successMsg} />;
            case 'unlocking-code':
                return <EirOnlineUnlockingCodeForm action={this.props.formAction} email={this.props.email} formName={this.props.formName} successMsg={this.props.successMsg} />;
            default:
                return <EirOnlineBereavementForm action={this.props.formAction} email={this.props.email} formName={this.props.formName} />;
        }
    }

    render() {
        console.log("from render", this.props.email);
        console.log('this.props', this.props)

        return (
            <div>
               {this.renderForm()}

            </div>
        )
    }
}

export default EirOnlineFormLandingPage


